export default "__VITE_ASSET__mFpbeH$v__"